import {
  CENTERED_LAYOUT_BASE_CLASSNAME,
  DesignProvider,
  LAYOUT_BASE_CLASSNAME,
  LocaleProvider,
  useDesignContext,
} from '@systemeio/digital-store-shared'
import { LocaleEnum } from '@systemeio/ui'
import { useStorePreviewContext } from 'modules/stores/store/context/store-preview-context'
import { useStore } from 'modules/stores/store/hooks/use-store'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'
import React, { FC, Fragment } from 'react'
import Frame, { FrameContextConsumer } from 'react-frame-component'
import { Loader } from 'shared/components/loader'
import { twMerge } from 'tailwind-merge'

const HIDE_SCROLLBAR_CSS =
  'html{-ms-overflow-style:none;scrollbar-width:none;}html::-webkit-scrollbar{display:none;}'

const PreviewBox: FC = () => {
  const { preview, singleItemMode, css } = useStorePreviewContext()

  const { storeId } = useStoreQuery()

  const { data: storeView } = useStore(storeId)

  const { state } = useDesignContext()

  const initialContent = `<!DOCTYPE html><html><head><style>${css}${HIDE_SCROLLBAR_CSS}</style></head><body></body></html>`

  return (
    <div className="noScrollbar sliderScroll h-full max-h-[720px] w-[360px] overflow-y-auto overflow-x-hidden rounded-[30px] border-[5px] border-black lg:shrink-0">
      {!!preview.length ? (
        <Frame
          mountTarget="body"
          initialContent={initialContent}
          width="100%"
          height="100%"
          tabIndex={-1}
        >
          <FrameContextConsumer>
            {({ document }) => (
              <LocaleProvider locale={storeView?.locale ?? LocaleEnum.ENGLISH}>
                <DesignProvider design={state} customRoot={document}>
                  <div
                    className={twMerge(
                      singleItemMode ? CENTERED_LAYOUT_BASE_CLASSNAME : LAYOUT_BASE_CLASSNAME,
                    )}
                    style={{
                      pointerEvents: 'none',
                    }}
                    // @ts-expect-error
                    inert={''}
                  >
                    {preview.map((item, index) => (
                      <Fragment key={index}>{item}</Fragment>
                    ))}
                  </div>
                </DesignProvider>
              </LocaleProvider>
            )}
          </FrameContextConsumer>
        </Frame>
      ) : (
        <div className={'flex h-full items-center justify-center'}>
          <Loader type={'dark'} />
        </div>
      )}
    </div>
  )
}

export default PreviewBox
